// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PatientResponseModel {
    static getAttributeTypeMap() {
        return PatientResponseModel.attributeTypeMap;
    }
}
PatientResponseModel.discriminator = undefined;
PatientResponseModel.additionalProperties = false;
PatientResponseModel.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=patientResponseModel.js.map